export default __webpack_public_path__ + "static/media/Price Tag.a599ad2b.svg";